import { Injectable } from "@angular/core";
import {Action, Selector, State, StateContext, StateToken, Store} from "@ngxs/store";
import { TfModulesService } from "./tfmodules.service";
import {
  ClearTfModuleRepository,
  LoadTfModulesData,
  SetTfModuleRepositoryByName,
  SetTfModuleRepositoryByPath,
  SetTfModulesFactorisationMode
} from "./tfmodules.actions";
import { TfModulesStateModel } from "./tfmodules.model";
import { FactorisationModeEnum } from "src/app/shared/enum/factorisation-mode.enum";
import { MetaService } from "src/app/store/meta/meta.service";
import { MetaRequestHelper } from "src/app/store/meta/meta-request.helper";

export const TFMODULES_TOKEN: StateToken<TfModulesStateModel> = new StateToken('tfModules');
const TfModulesStateModelDefault: TfModulesStateModel = {
  repositories: [],
  factorisationMode: FactorisationModeEnum.USAGE,
  selectedRepository: {
    name: "",
    url: "",
    age: 0,
    full_path: "",
    tfmodules: [],
    archived: false,
    type: ""
  }
}

@State<TfModulesStateModel>({
    name: TFMODULES_TOKEN,
    defaults: TfModulesStateModelDefault
})
@Injectable()
export class TfModulesState {

    private readonly KEY = TFMODULES_TOKEN.getName()

    constructor(
        private tfModulesService: TfModulesService,
        private metaService: MetaService,
        private store: Store
    ) {
    }

    @Selector([TFMODULES_TOKEN])
    static getRepositories(state: TfModulesStateModel) {
        return state.repositories
    }

    @Selector([TFMODULES_TOKEN])
    static getFactorisationMode(state: TfModulesStateModel) {
        return state.factorisationMode
    }

    @Selector([TFMODULES_TOKEN])
    static getSelectedRepository(state: TfModulesStateModel) {
        return state.selectedRepository
    }

    @Action(LoadTfModulesData)
    loadTfModulesData(ctx: StateContext<TfModulesStateModel>) {
        const TFMODULE_KEY = this.KEY
        if(!this.metaService.isStale(TFMODULE_KEY)) return

        return MetaRequestHelper.wrapRequest(
            this.store,
            TFMODULE_KEY,
            this.tfModulesService.loadTfModulesData(),
            payload => {
                ctx.patchState(
                    {
                        repositories: payload
                    }
                )
            }
        )
    }

    @Action(SetTfModulesFactorisationMode)
    setTfModulesFactorisationMode(ctx: StateContext<TfModulesStateModel>, payload: any){
        return ctx.patchState({
            factorisationMode: payload.payload
        })
    }

    @Action(ClearTfModuleRepository)
    clearTfModuleRepository(ctx: StateContext<TfModulesStateModel>){
        return ctx.patchState({
            selectedRepository: TfModulesStateModelDefault.selectedRepository
        })
    }

    @Action(SetTfModuleRepositoryByPath)
    setTfModuleRepository(ctx: StateContext<TfModulesStateModel>, payload: any){
        const state = ctx.getState()
        state.repositories.forEach(repository => {
            if (repository.full_path == payload.payload) {
                ctx.patchState({
                    selectedRepository: repository
                })
            }
        })
    }
    @Action(SetTfModuleRepositoryByName, { cancelUncompleted: true })
    setSpecificTfModuleRepository(ctx: StateContext<TfModulesStateModel>, action: SetTfModuleRepositoryByName){
        const state = ctx.getState().repositories
        let repository = state.find((element) => element.name == action.name)
        if(repository != undefined) {
            ctx.patchState({
                selectedRepository: repository
            })
        }
    }
}
